// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8e914872","453":"df1c68e6"}[chunkId] + ".chunk.js";
};